module.exports = __webpack_public_path__ + "img/award-cosmo.bfe45f4a.jpg";